import React, { useState } from "react";
// Import your images here

import intershipduration from "../../../assets/images/intershipduration.svg";
import intershiptype from "../../../assets/images/intershiptype.svg";
import booktimeslot from "../../../assets/images/booktimeslot.svg";
import bookseat from "../../../assets/images/book-seat.svg";
import finishyourprogress from "../../../assets/images/finish-your-progress.svg";
import personalinfo from "../../../assets/images/personal-info-icon.png";

const InternshipSectionDevops = () => {
  const [activeTab, setActiveTab] = useState("basics"); // Default tab

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <section id="devops">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h2 className="text-purple">6-Month DevOps Roadmap </h2>
              <p className="fw-medium">(From Scratch to Expert)</p>
            </div>
          </div>
          <div className="row my-5 devcontaint">
            <div className="col-md-3 col-12">
              <div className="left-side h-100 flex-md-row flex-column">
                <ul className="d-md-block d-flex">
                  {/* Tab Buttons */}
                  <li role='button'
                    className={`d-flex flex-md-row flex-column ${activeTab === 'basics' ? 'active' : ''}`}
                    onClick={() => handleTabClick('basics')}
                  >
                    <div className={`fs-1 image-section type2    ${activeTab === 'basics' ? '' : '  '}`}>
                      1
                    </div>
                    <div className={`text-section d-md-inline ${activeTab === 'basics' ? 'text-danger d-inline' : 'd-none'}`}>
                      <h6 className="fw-bold" >Basics</h6>
                    </div>
                  </li>

                  <li
                    role='button' className={`d-flex flex-md-row flex-column ${activeTab === 'CI/CD' ? 'active ' : ''}`}
                    onClick={() => handleTabClick('CI/CD')}
                  >
                    <div className="image-section type2 fs-2">
                      2
                    </div>
                    <div className={`text-section  d-md-inline ${activeTab === 'CI/CD' ? 'text-danger d-inline' : 'd-none'}`}>
                      <h6 className="fw-bold"> CI/CD</h6>
                    </div>
                  </li>

                  <li role='button'
                    className={`d-flex flex-md-row flex-column ${activeTab === 'Configuration Management' ? 'active' : ''}`}
                    onClick={() => handleTabClick('Configuration Management')}
                  >
                    <div className="image-section type2 fs-1">
                      3
                    </div>
                    <div className={`text-section  d-md-inline ${activeTab === 'Configuration Management' ? 'text-danger d-inline' : 'd-none'}`}>
                      <h6 className="fw-bold">Configuration Management </h6>
                    </div>
                  </li>

                  <li role='button'
                    className={`d-flex flex-md-row flex-column ${activeTab === 'MongoDB' ? 'active' : ''}`}
                    onClick={() => handleTabClick('MongoDB')}
                  >
                    <div className="image-section type2 fs-1">
                      4
                    </div>
                    <div className={`text-section  d-md-inline ${activeTab === 'MongoDB' ? 'text-danger d-inline' : 'd-none'}`}>
                      <h6 className="fw-bold">Container Management</h6>
                    </div>
                  </li>

                  <li role='button'
                    className={`d-flex flex-md-row flex-column ${activeTab === 'full-stack' ? 'active' : ''}`}
                    onClick={() => handleTabClick('full-stack')}
                  >
                    <div className="image-section type2 fs-1 ">
                      5
                    </div>
                    <div className={`text-section  d-md-inline ${activeTab === 'full-stack' ? 'text-danger d-inline' : 'd-none'}`}>
                      <h6 className="fw-bold">
                      DevOps Security</h6>
                    </div>
                  </li>

                  <li role='button'
                    className={`d-flex flex-md-row flex-column ${activeTab === 'interview-preparation' ? 'active' : ''}`}
                    onClick={() => handleTabClick('interview-preparation')}
                  >
                    <div className="image-section type2 fs-1" >
                      6
                    </div>
                    <div className={`text-section  d-md-inline ${activeTab === 'interview-preparation' ? 'text-danger d-inline' : 'd-none'}`}>
                      <h6 className="fw-bold">Interview preparations</h6>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-9 col-12">
              <div className="right-side">
                {activeTab === 'basics' && (
                  <div className=" mt-4">
                    <h1 className="fw-bold fs-3 text-danger mb-3">Introduction to  DevOps, Version Control, and Cloud Basics</h1>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 1-2: Understanding DevOps & Version Control</strong>
                    <ul className="ms-4">
                      <li>
                        <strong className=''>Introduction to DevOps:</strong>
                        <ul>
                          <li className='ms-3'><strong>What is DevOps?</strong> The DevOps culture, principles, and benefits.</li>
                          <li className='ms-3'><strong>The DevOps lifecycle:</strong> Continuous Development, Continuous Integration (CI), Continuous Deployment (CD), Continuous Testing, Continuous Monitoring, and Continuous Feedback.</li>
                          <li className='ms-3'><strong>Overview of DevOps tools and the ecosystem.</strong></li>
                        </ul>
                      </li>
                      <li>
                        <strong className=''>Version Control:</strong>
                        <ul>
                          <li className='ms-3'><strong>Introduction to Git:</strong> Git basics (commit, push, pull, branch, merge).</li>
                          <li className='ms-3'><strong>Working with GitHub or GitLab:</strong> Repository management and collaboration.</li>
                          <li className='ms-3'><strong>Collaboration workflows:</strong> Fork, clone, pull requests, and merging.</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 3-4: Introduction to Cloud & Basic Infrastructure Management</strong>
                    <ul className="ms-4">
                      <li>
                        <strong className=''>Cloud Computing Basics:</strong>
                        <ul>
                          <li className='ms-3'><strong>Introduction to AWS, Azure, and Google Cloud:</strong> Overview of the three major cloud platforms and their services.</li>
                          <li className='ms-3'><strong>Creating and managing EC2 instances (AWS) or Virtual Machines (Azure, GCP):</strong> Spin up instances/VMs and basic management.</li>
                          <li className='ms-3'><strong>Understanding cloud storage services:</strong> AWS S3 (Simple Storage Service), Azure Blob Storage.</li>
                        </ul>
                      </li>
                      <li>
                        <strong className=''>Cloud CLI:</strong>
                        <ul>
                          <li className='ms-3'><strong>Basic command-line usage for cloud platforms:</strong> AWS CLI, Azure CLI.</li>
                          <li className='ms-3'><strong>Managing cloud resources from the command line.</strong></li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Key Tools/Technologies:</strong>
                    <ul className="ms-4">
                      <li>Git, GitHub, GitLab</li>
                      <li>AWS, Azure, Google Cloud</li>
                      <li>AWS CLI, Azure CLI</li>
                    </ul>
                  </div>

                )}
                {activeTab === 'CI/CD' && (
                  <div className=" mt-4">
                    <h1 className="fw-bold fs-3 text-danger mb-3">CI/CD Pipeline Basics & Containerization</h1>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 5-6: Continuous Integration & Deployment (CI/CD)</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>CI/CD Overview:</strong>
                        <ul>
                          <li className='ms-3'><strong>What is Continuous Integration and Continuous Deployment?</strong></li>
                          <li className='ms-3'><strong>Setting up Jenkins or GitLab CI to automate build, test, and deployment:</strong></li>
                          <li className='ms-3'><strong>Introduction to Travis CI and CircleCI:</strong> Overview and usage of other CI tools.</li>
                          <li className='ms-3'><strong>Creating simple CI/CD pipelines:</strong> Integration with Git, automated tests, and deployment to the cloud.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Automating Builds:</strong>
                        <ul>
                          <li className='ms-3'><strong>Introduction to build automation:</strong> Using Maven or Gradle.</li>
                          <li className='ms-3'><strong>Build and deploy simple applications:</strong> Automating the process using a CI tool.</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 7-8: Containerization with Docker</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>Introduction to Docker:</strong>
                        <ul>
                          <li className='ms-3'><strong>What is Docker?</strong> Overview of containerization.</li>
                          <li className='ms-3'><strong>Creating Docker containers and Docker images:</strong> Practical examples of Docker containers and images.</li>
                          <li className='ms-3'><strong>Introduction to Docker Hub and Dockerfile:</strong> Pushing and pulling images from Docker Hub and creating Dockerfiles.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Docker Compose:</strong>
                        <ul>
                          <li className='ms-3'><strong>Understanding multi-container applications:</strong> How Docker Compose simplifies the management of multiple containers.</li>
                          <li className='ms-3'><strong>Using Docker Compose:</strong> Managing multi-container setups.</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Key Tools/Technologies:</strong>
                    <ul className="ms-4">
                      <li>Jenkins, GitLab CI, Travis CI, CircleCI</li>
                      <li>Docker, Docker Compose</li>
                      <li>Maven, Gradle</li>
                    </ul>
                  </div>
                )}
                {activeTab === 'Configuration Management' && (
                  <div className="container mt-4">
                    <h1 className="fw-bold fs-3 text-danger mb-3">Configuration Management & Infrastructure Automation</h1>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 9-10: Configuration Management Tools</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>Ansible – </strong>
                        <ul>
                          <li className="fs-6">Introduction to Ansible: playbooks, roles, and tasks.</li>
                          <li className="fs-6">Automating server configuration with Ansible.</li>
                          <li className="fs-6">Deploying applications using Ansible.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Puppet / Chef (Optional) – </strong>
                        <ul>
                          <li className="fs-6">Introduction to Puppet or Chef as alternative configuration management tools.</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 11-12: Infrastructure as Code (IaC)</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>Introduction to IaC – </strong>
                        <ul>
                          <li className="fs-6">Overview of Terraform for provisioning cloud infrastructure.</li>
                          <li className="fs-6">Introduction to AWS CloudFormation as an alternative to Terraform.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Working with Terraform – </strong>
                        <ul>
                          <li className="fs-6">Setting up and provisioning resources in AWS using Terraform.</li>
                          <li className="fs-6">Creating infrastructure for applications: VPC, EC2, S3, RDS.</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Key Tools/Technologies:</strong>
                    <ul className="ms-4">
                      <li className="fs-6">Ansible</li>
                      <li className="fs-6">Puppet or Chef (optional)</li>
                      <li className="fs-6">Terraform, AWS CloudFormation</li>
                    </ul>
                  </div>

                )}



                {activeTab === 'MongoDB' && (
                  <div className="container mt-4">
                    <h1 className="fw-bold fs-3 text-danger mb-3"> Kubernetes & Container Orchestration</h1>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 13-14: Introduction to Kubernetes</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>Kubernetes Basics – </strong>
                        <ul>
                          <li className="fs-6">What is Kubernetes? Key concepts like Pods, Deployments, Services, Namespaces, and ReplicaSets.</li>
                          <li className="fs-6">Kubernetes architecture: Master node, Worker node, Kubelet, etc.</li>
                          <li className="fs-6">Installing and configuring a Kubernetes cluster (Minikube, Kubeadm, or Cloud-managed K8s).</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 15-16: Kubernetes for Container Orchestration</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>Managing Kubernetes Resources – </strong>
                        <ul>
                          <li className="fs-6">Deploying applications on Kubernetes.</li>
                          <li className="fs-6">Scaling applications and managing replicas.</li>
                          <li className="fs-6">Understanding and implementing Helm for Kubernetes package management.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Kubernetes Networking – </strong>
                        <ul>
                          <li className="fs-6">Setting up services for communication between Pods.</li>
                          <li className="fs-6">Exposing services to the outside world (Ingress, LoadBalancers).</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Key Tools/Technologies:</strong>
                    <ul className="ms-4">
                      <li className="fs-6">Kubernetes</li>
                      <li className="fs-6">Helm</li>
                      <li className="fs-6">Minikube, Kubeadm</li>
                    </ul>
                  </div>

                )}

                {activeTab === 'full-stack' && (
                  <div className="container mt-4">
                    <h1 className="fw-bold fs-3 text-danger mb-3">Monitoring, Logging, & Security in DevOps</h1>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 17-18: Monitoring & Logging</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>Monitoring Tools – </strong>
                        <ul>
                          <li className="fs-6">Introduction to Prometheus for monitoring Kubernetes and cloud resources.</li>
                          <li className="fs-6">Setting up Grafana for visualization and alerting.</li>
                          <li className="fs-6">Integrating Prometheus and Grafana for application monitoring.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Logging Tools – </strong>
                        <ul>
                          <li className="fs-6">Introduction to the ELK Stack (Elasticsearch, Logstash, Kibana).</li>
                          <li className="fs-6">Setting up logging for containers and Kubernetes.</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 19-20: Security in DevOps (DevSecOps)</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>Introduction to DevSecOps – </strong>
                        <ul>
                          <li className="fs-6">Integrating security into the CI/CD pipeline.</li>
                          <li className="fs-6">Using Aqua Security or Sysdig for container security.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Kubernetes Security – </strong>
                        <ul>
                          <li className="fs-6">Securing Kubernetes clusters using RBAC, Network Policies, and Secrets Management.</li>
                          <li className="fs-6">Introduction to HashiCorp Vault for managing secrets and sensitive data.</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Key Tools/Technologies:</strong>
                    <ul className="ms-4">
                      <li className="fs-6">Prometheus, Grafana</li>
                      <li className="fs-6">ELK Stack</li>
                      <li className="fs-6">Aqua Security, HashiCorp Vault</li>
                      <li className="fs-6">Sysdig</li>
                    </ul>
                  </div>

                )}

                {activeTab === 'interview-preparation' && (
                  <div className="container mt-4">
                    <h1 className="fw-bold fs-3 text-danger mb-3">Month 6: Advanced Topics, Multi-Cloud, Disaster Recovery, and Interview Preparation</h1>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 21-22: Multi-Cloud & Disaster Recovery</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>Multi-Cloud Deployment – </strong>
                        <ul>
                          <li className="fs-6">Overview of multi-cloud architectures and strategies.</li>
                          <li className="fs-6">Deploying and managing applications across AWS, Azure, and GCP.</li>
                          <li className="fs-6">Integrating multi-cloud services into the DevOps pipeline.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Disaster Recovery & High Availability – </strong>
                        <ul>
                          <li className="fs-6">Designing disaster recovery strategies in the cloud.</li>
                          <li className="fs-6">Implementing high-availability (HA) setups using cloud-native services (Load Balancers, Autoscaling).</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Week 23-24: Interview Preparation & Mock Interviews</strong>
                    <ul className="ms-4">
                      <li>
                        <strong>Resume Building – </strong>
                        <ul>
                          <li className="fs-6">Crafting a DevOps-focused resume with hands-on project experience.</li>
                          <li className="fs-6">Writing a strong cover letter highlighting DevOps skills.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Aptitude & Technical Interview Preparation – </strong>
                        <ul>
                          <li className="fs-6">Preparing for common DevOps interview questions.</li>
                          <li className="fs-6">Practice coding questions and algorithms for technical interviews (Linux commands, scripting).</li>
                          <li className="fs-6">Understanding system design concepts and architecture.</li>
                        </ul>
                      </li>
                      <li>
                        <strong>Mock Interviews – </strong>
                        <ul>
                          <li className="fs-6">Conduct mock technical interviews focusing on DevOps, CI/CD, Kubernetes, Cloud, and Security.</li>
                          <li className="fs-6">Soft skills training for interviews (communication, problem-solving).</li>
                        </ul>
                      </li>
                    </ul>

                    <strong className="fw-bold fs-5 text-danger mb-2">Key Tools/Technologies:</strong>
                    <ul className="ms-4">
                      <li className="fs-6">Multi-cloud deployment (AWS, Azure, GCP)</li>
                      <li className="fs-6">Disaster Recovery and High Availability</li>
                    </ul>
                  </div>

                )}
              </div>
            </div>
          </div>


        </div >
      </section >
    </>
  );
};

export default InternshipSectionDevops;

// <section className="internship" id="rounded-box-lg">
//   <div className="container">
//     <div className="bg-white">
//       <div className="top-grid">
//         <div className="left">
//           <h2 className="text-purple">6-Month DevOps Roadmap </h2>
//           <p className="fw-medium">From Scratch to Expert</p>
//         </div>
//         <div className="right">
//           <p className="text-gray fw-medium">
//             Fill all form fields to go to next step
//           </p>
//         </div>
//       </div>

//       <div className="intership-grid">
// <div className="left-side">
//   <ul>
//     {/* Tab Buttons */}
//     <li role='button'
//       className={`d-flex ${activeTab === 'basics ' ? 'active' : ''}`}
//       onClick={() => handleTabClick('basics')}
//     >
//       <div className={`fs-1 image-section    ${activeTab === 'basics  months-type' ? ' ' : 'type2'}`}>
//         1
//       </div>
//       <div className={`text-section ${activeTab === 'basics' ? 'text-danger' : ''}`}>
//         <h6 className="fw-bold" >Basics</h6>
//       </div>
//     </li>

//     <li
//       role='button' className={`d-flex ${activeTab === ' CI/CD' ? 'active ' : ''}`}
//       onClick={() => handleTabClick(' CI/CD')}
//     >
//       <div className="image-section type2 fs-2">
//         2
//       </div>
//       <div className={`text-section ${activeTab === ' CI/CD' ? 'text-danger' : ''}`}>
//         <h6 className="fw-bold"> CI/CD</h6>
//       </div>
//     </li>

//     <li role='button'
//       className={`d-flex ${activeTab === 'Configuration Management' ? 'active' : ''}`}
//       onClick={() => handleTabClick('Configuration Management')}
//     >
//       <div className="image-section type2 fs-1">
//         3
//       </div>
//       <div className={`text-section ${activeTab === 'Configuration Management' ? 'text-danger  ' : ''}`}>
//         <h6 className="fw-bold">Configuration Management </h6>
//       </div>
//     </li>

//     <li role='button'
//       className={`d-flex ${activeTab === 'MongoDB' ? 'active' : ''}`}
//       onClick={() => handleTabClick('MongoDB')}
//     >
//       <div className="image-section type2 fs-1">
//         4
//       </div>
//       <div className={`text-section ${activeTab === 'MongoDB' ? 'text-danger  ' : ''}`}>
//         <h6 className="fw-bold">MongoDB</h6>
//       </div>
//     </li>

//     <li role='button'
//       className={`d-flex ${activeTab === 'full-stack' ? 'active' : ''}`}
//       onClick={() => handleTabClick('full-stack')}
//     >
//       <div className="image-section type2 fs-1 ">
//         5
//       </div>
//       <div className={`text-section ${activeTab === 'full-stack' ? 'text-danger  ' : ''}`}>
//         <h6 className="fw-bold">Full Stack</h6>
//       </div>
//     </li>

//     <li role='button'
//       className={`d-flex ${activeTab === 'interview-preparation' ? 'active' : ''}`}
//       onClick={() => handleTabClick('interview-preparation')}
//     >
//       <div className="image-section type2 fs-1" >
//         6
//       </div>
//       <div className={`text-section ${activeTab === 'interview-preparation' ? 'text-danger  ' : ''}`}>
//         <h6 className="fw-bold">Interview preparations</h6>
//       </div>
//     </li>
//   </ul>
// </div>

//       <div className="right-side">
//         {activeTab === 'basics' && (
//         <div className="container mt-4">
//         <h1 className="fw-bold fs-3 text-danger mb-3">Month 1: Introduction to  DevOps, Version Control, and Cloud Basics</h1>

//         <strong className="fw-bold fs-5 text-danger mb-2">Week 1-2: Understanding DevOps & Version Control</strong>
//         <ul className="ms-4">
//           <li>
//             <strong className=''>Introduction to DevOps:</strong>
//             <ul>
//               <li  className='ms-3'><strong>What is DevOps?</strong> The DevOps culture, principles, and benefits.</li>
//               <li className='ms-3'><strong>The DevOps lifecycle:</strong> Continuous Development, Continuous Integration (CI), Continuous Deployment (CD), Continuous Testing, Continuous Monitoring, and Continuous Feedback.</li>
//               <li className='ms-3'><strong>Overview of DevOps tools and the ecosystem.</strong></li>
//             </ul>
//           </li>
//           <li>
//             <strong className='fs-4'>Version Control:</strong>
//             <ul>
//               <li  className='ms-3'><strong>Introduction to Git:</strong> Git basics (commit, push, pull, branch, merge).</li>
//               <li  className='ms-3'><strong>Working with GitHub or GitLab:</strong> Repository management and collaboration.</li>
//               <li  className='ms-3'><strong>Collaboration workflows:</strong> Fork, clone, pull requests, and merging.</li>
//             </ul>
//           </li>
//         </ul>

//         <strong className="fw-bold fs-5 text-danger mb-2">Week 3-4: Introduction to Cloud & Basic Infrastructure Management</strong>
//         <ul className="ms-4">
//           <li>
//             <strong className='fs-4'>Cloud Computing Basics:</strong>
//             <ul>
//               <li  className='ms-3'><strong>Introduction to AWS, Azure, and Google Cloud:</strong> Overview of the three major cloud platforms and their services.</li>
//               <li  className='ms-3'><strong>Creating and managing EC2 instances (AWS) or Virtual Machines (Azure, GCP):</strong> Spin up instances/VMs and basic management.</li>
//               <li  className='ms-3'><strong>Understanding cloud storage services:</strong> AWS S3 (Simple Storage Service), Azure Blob Storage.</li>
//             </ul>
//           </li>
//           <li>
//             <strong className='fs-4'>Cloud CLI:</strong>
//             <ul>
//               <li  className='ms-3'><strong>Basic command-line usage for cloud platforms:</strong> AWS CLI, Azure CLI.</li>
//               <li  className='ms-3'><strong>Managing cloud resources from the command line.</strong></li>
//             </ul>
//           </li>
//         </ul>

//         <strong className="fw-bold fs-5 text-danger mb-2">Key Tools/Technologies:</strong>
//         <ul className="ms-4">
//           <li>Git, GitHub, GitLab</li>
//           <li>AWS, Azure, Google Cloud</li>
//           <li>AWS CLI, Azure CLI</li>
//         </ul>
//       </div>

//         )}

//         {activeTab === 'Configuration Management' && (
//          <div className="container mt-4">
//          <p className="fw-bold fs-4 text-danger mb-3">Week 3-4: Introduction to Cloud & Basic Infrastructure Management</p>

//          <ul className="list-unstyled">
//            <li className="mb-3">
//              <strong>Cloud Computing Basics:</strong>
//              <ul className="ms-3">
//                <li className="mb-2">Introduction to AWS, Azure, and Google Cloud.</li>
//                <li className="mb-2">Creating and managing EC2 instances (AWS) or Virtual Machines (Azure, GCP).</li>
//                <li className="mb-2">Understanding cloud storage services like S3 (AWS) and Blob Storage (Azure).</li>
//              </ul>
//            </li>

//            <li className="fs-6 mb-3">
//              <strong>Cloud CLI:</strong>
//              <ul className="ms-3">
//                <li className="mb-2">Basic command-line usage for cloud platforms (AWS CLI, Azure CLI).</li>
//                <li className="mb-2">Managing cloud resources from the command line.</li>
//              </ul>
//            </li>
//          </ul>

//          <div className="d-flex justify-content-center mt-4">
//            <button className="btn btn-dark text-white px-4 py-2">Next</button>
//          </div>
//        </div>
//         )}

//         {activeTab === ' CI/CD' && (
//           <div className="container mt-4">
//           <h1 className="fw-bold fs-3 text-danger mb-3">Month 2: CI/CD Pipeline Basics & Containerization</h1>

//           <strong className="fw-bold fs-5 text-danger mb-2">Week 5-6: Continuous Integration & Deployment (CI/CD)</strong>
//           <ul className="ms-4">
//             <li>
//               <strong>CI/CD Overview:</strong>
//               <ul>
//                 <li  className='ms-3'><strong>What is Continuous Integration and Continuous Deployment?</strong></li>
//                 <li  className='ms-3'><strong>Setting up Jenkins or GitLab CI to automate build, test, and deployment:</strong></li>
//                 <li  className='ms-3'><strong>Introduction to Travis CI and CircleCI:</strong> Overview and usage of other CI tools.</li>
//                 <li  className='ms-3'><strong>Creating simple CI/CD pipelines:</strong> Integration with Git, automated tests, and deployment to the cloud.</li>
//               </ul>
//             </li>
//             <li>
//               <strong>Automating Builds:</strong>
//               <ul>
//                 <li  className='ms-3'><strong>Introduction to build automation:</strong> Using Maven or Gradle.</li>
//                 <li  className='ms-3'><strong>Build and deploy simple applications:</strong> Automating the process using a CI tool.</li>
//               </ul>
//             </li>
//           </ul>

//           <strong className="fw-bold fs-5 text-danger mb-2">Week 7-8: Containerization with Docker</strong>
//           <ul className="ms-4">
//             <li>
//               <strong>Introduction to Docker:</strong>
//               <ul>
//                 <li  className='ms-3'><strong>What is Docker?</strong> Overview of containerization.</li>
//                 <li  className='ms-3'><strong>Creating Docker containers and Docker images:</strong> Practical examples of Docker containers and images.</li>
//                 <li  className='ms-3'><strong>Introduction to Docker Hub and Dockerfile:</strong> Pushing and pulling images from Docker Hub and creating Dockerfiles.</li>
//               </ul>
//             </li>
//             <li>
//               <strong>Docker Compose:</strong>
//               <ul>
//                 <li className='ms-3'><strong>Understanding multi-container applications:</strong> How Docker Compose simplifies the management of multiple containers.</li>
//                 <li  className='ms-3'><strong>Using Docker Compose:</strong> Managing multi-container setups.</li>
//               </ul>
//             </li>
//           </ul>

//           <strong className="fw-bold fs-5 text-danger mb-2">Key Tools/Technologies:</strong>
//           <ul className="ms-4">
//             <li>Jenkins, GitLab CI, Travis CI, CircleCI</li>
//             <li>Docker, Docker Compose</li>
//             <li>Maven, Gradle</li>
//           </ul>
//         </div>
//         )}

//         {activeTab === 'MongoDB' && (
//           <div>
//             <p className="fw-medium">Select Timing Slot</p>
//             <div className="form-top">
//               <form className="intership-radio text-gray">
//                 <div className="form-group">
//                   <label>
//                     <input type="radio" name="timeslot" value="morning" />
//                     Morning
//                   </label>
//                 </div>
//                 <div className="form-group">
//                   <label>
//                     <input type="radio" name="timeslot" value="afternoon" />
//                     Afternoon
//                   </label>
//                 </div>
//                 <div className="form-group">
//                   <label>
//                     <input type="radio" name="timeslot" value="evening" />
//                     Evening
//                   </label>
//                 </div>
//               </form>
//             </div>
//             <div className="d-flex btn-wraper">
//               <button className="btn btn-black text-white">Next</button>
//             </div>
//           </div>
//         )}

//         {activeTab === 'full-stack' && (
//           <div>
//             <p className="fw-medium">Select a Seat</p>
//             <div className="form-top">
//               {/* Seat selection form here */}
//             </div>

//           </div>
//         )}

//         {activeTab === 'interview-preparation' && (
//           <div>
//             <p className="fw-medium">Finish Your Progress</p>
//             <div className="form-top">
//               {/* Progress finishing form here */}
//             </div>
//             <div className="d-flex btn-wraper">
//               <button className="btn btn-black text-white">Submit</button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   </div>
// </div>

// </section>
